import React from 'react';
import {
  AbsoluteFill,
  Img,
  interpolate,
  spring,
  staticFile,
  useCurrentFrame,
  useVideoConfig,
} from 'remotion';
import {brand, brandFont} from '../brand';

export const BrandIntro: React.FC<{tagline?: string}> = ({tagline = 'AI WOD Timer'}) => {
  const frame = useCurrentFrame();
  const {fps} = useVideoConfig();

  const scale = spring({frame, fps, from: 0.6, to: 1, config: {damping: 12}});
  const opacity = interpolate(frame, [0, 12], [0, 1], {extrapolateRight: 'clamp'});

  return (
    <AbsoluteFill style={{justifyContent: 'center', alignItems: 'center', gap: 40}}>
      <Img
        src={staticFile('logo.png')}
        style={{
          width: 280,
          height: 280,
          borderRadius: 60,
          transform: `scale(${scale})`,
          opacity,
          boxShadow: `0 20px 80px ${brand.primary}55`,
        }}
      />
      <div
        style={{
          fontFamily: brandFont,
          fontSize: 64,
          fontWeight: 700,
          color: brand.textPrimary,
          letterSpacing: -1,
          opacity,
        }}
      >
        {tagline}
      </div>
    </AbsoluteFill>
  );
};
